import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ko from "./ko.json";
import en from "./en.json";
import ja from "./ja.json";

const userLang = window.__DEVICE__?.language || "ko";

export const initI18n = () => {
  i18n.use(initReactI18next).init({
    resources: {
      ko: { translation: ko },
      en: { translation: en },
      ja: { translation: ja },
    },
    lng: userLang,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
};

export default initI18n;
